// extracted by mini-css-extract-plugin
export default {"modal":"vacancies-modal_modal__umQHh","title":"vacancies-modal_title__o-6KL","top":"vacancies-modal_top__RaFF6","linkText":"vacancies-modal_linkText__9kCFI"};